import React, {useEffect, useState} from "react";
import DashboardLayout from "../../layouts/Dashboard";
import {useTranslation} from "react-i18next";
import {SearchPanel, TableCustom} from "../../components";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Box from "@mui/material/Box";
import {Button} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {
    addServiceKind,
    deleteServiceKind,
    editServiceKind,
    getServiceKindByKey,
    getServiceKinds
} from "../../redux/actions/serviceKindActions";
import CreateServiceKind from "./Popups/CreateServiceKind";
import ServiceKindDetails from "./Popups/ServiceKindDetails";
import EditServiceKind from "./Popups/EditServiceKind";
import RemoveServiceKind from "./Popups/RemoveServiceKind";

function createData(id, name, code, description) {
    return {id, name, code, description};
}

let rows = [
    createData(1, "abc", "abc", "abc"),
];
const ServiceKindList = () => {
    const {t} = useTranslation();
    const rowName = [
        {text: t("serviceKindList.tableItem.id")},
        {text: t("serviceKindList.tableItem.name")},
        {text: t("serviceKindList.tableItem.code")},
        {text: t("serviceKindList.tableItem.description")},
        {text: t("serviceKindList.tableItem.actions")},
    ];
    const dispatch = useDispatch();

    const [query, setQuery] = useState({ "sort": { "id": { "operator": "asc" } } });

    const [id, setId] = useState(null);
    const [createOpen, setCreateOpen] = useState(false);
    const setCreateHandler = async () => {
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setCreateOpen(true);
        setId(null);
    }
    const createSubmit = async (_) => {
        await dispatch(addServiceKind(_, query));
    }
    const [detailsOpen, setDetailsOpen] = useState(false);
    const setDetailsHandler = async (id) => {
        await dispatch(getServiceKindByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setDetailsOpen(true);
        setId(id);
    }

    const [editOpen, setEditOpen] = useState(false);
    const setEditHandler = async (id) => {
        await dispatch(getServiceKindByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setEditOpen(true);
        setId(id);
    }
    const editSubmit = async (_) => {
        await dispatch(editServiceKind(_, query));
    }
    const [removeOpen, setRemoveOpen] = useState(false);
    const setRemoveHandler = async (id) => {
        await dispatch(getServiceKindByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setRemoveOpen(true);
        setId(id);
    }
    const removeSubmit = async (_) => {
        await dispatch(deleteServiceKind(_.id, query));
    }

    const localData = false;
    const state = useSelector((state) => state.serviceKind);
    if (!localData && state.serviceKinds) {
        rows = state.serviceKinds;
    }
    useEffect(() => {
        if (!localData) {
            dispatch(getServiceKinds(query));
        }

        console.log(rows)
    }, [dispatch])



    return (
        <DashboardLayout>
            <Box sx={{margin: '20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <SearchPanel searchName="id" search={rows} label={t("serviceKindList.searchLabel")}/>
                <Button color="primary" variant="contained" onClick={() => setCreateHandler()}>
                    {t("serviceKindList.createText")}
                </Button>
            </Box>
            <TableCustom avatars={false} rowName={rowName} rows={rows.map(_ => {
                return {
                    id: _.id,
                    name: _.name,
                    code: _.code,
                    description: _.description,
                }
            })} actions={(_) => [<VisibilityIcon onClick={() => setDetailsHandler(_.id)}/>,<EditIcon onClick={() => setEditHandler(_.id)}/>,<DeleteForeverIcon onClick={() => setRemoveHandler(_.id)}/>]}/>
            <CreateServiceKind action={'create'} title={t("serviceKindList.createText")} open={createOpen} setOpen={setCreateOpen} onSubmit={createSubmit}/>
            <ServiceKindDetails action={'details'} title={t("serviceKindList.detailsText")} open={detailsOpen} setOpen={setDetailsOpen} />
            <EditServiceKind action={'edit'} title={t("serviceKindList.editText")} open={editOpen} setOpen={setEditOpen} onSubmit={editSubmit}/>
            <RemoveServiceKind action={'remove'} title={t("serviceKindList.removeText")} open={removeOpen} setOpen={setRemoveOpen} onSubmit={removeSubmit}/>
        </DashboardLayout>
    )
};

export default ServiceKindList;
